<template>
    <div>
        <v-dialog v-model="showBudgetModal" @close="close"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                  scrollable
        >
            <v-card tile>
                <v-toolbar class="blue-grey darken-2 white--text" height="55px" card dark color="blue lighten-2">
                    <v-btn icon dark @click="close">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{getDocumentName}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-layout row wrap justify-center>
                            <v-flex xs12 sm12 md8 lg7 justify-center>


                                <v-flex xs12>
                                    <v-card>
                                        <!--<v-toolbar class="blue-grey darken-2 white&#45;&#45;text" card dark color="blue lighten-3">-->
                                        <!--<v-toolbar-title color="grey&#45;&#45;text">{{getDocumentName}} {{getBudgetCode ? 'nº '+getBudgetCode() : 'programada'}}</v-toolbar-title>-->
                                        <!--<v-spacer></v-spacer>-->
                                        <!--<v-chip ma-3 label outline color="yellow lighten-2">Rascunho</v-chip>-->
                                        <!--</v-toolbar>-->
                                        <v-progress-linear
                                                color="indigo"
                                                v-if="loadingExtraBudgetInfos"
                                                :indeterminate=true
                                                height="2"
                                                value="15"
                                        ></v-progress-linear>


                                        <div id="fac" ref="factura" v-if="extraInfosLoaded" style="font-family: sans-serif; margin: 8mm"
                                             :style="[isInvoiceA5Format ? {'min-height': '190mm'} : {'min-height':'280mm'}]">


                                            <!--Footer-->
                                            <div style="position: absolute; left: 0%; top: 93%; margin-left: 30px; width: 92%;">
                                                <div style="position: relative; bottom: 7%">
                                                    <v-flex xs12>
                                                        <p style="margin-bottom: 10px" :style="[isInvoiceA5Format ? {'font-size': '9px'} : {'font-size':'11px'}]">
                                                            Tributo especial unificado (TEU) nos termos da lei da alínea 3 do artigo nr.28 Decreto-lei nr.70/VIII/2014 de Agosto de 2014.
                                                        </p>
                                                        <v-divider></v-divider>
                                                    </v-flex>
                                                    <v-flex shrink>
                                                        <p style="margin-top: 2px" :style="[isInvoiceA5Format ? {'font-size': '9px'} : {'font-size':'11px'}]">
                                                            Processado pelo programa <b>NHA FATURA</b> licenciado pelo contribuinte./ &copy;<b>Laciftech</b>
                                                        </p>
                                                    </v-flex>
                                                </div>
                                            </div>

                                            <table class="table table-bordered" border="0" width="60%" style="padding: 0; margin: 0; float: left">
                                                <tr>
                                                    <td align="left" style="padding: 0; margin: 0;"
                                                        :style="[isInvoiceA5Format ? {'font-size': '11px'} : {'font-size':'12px'}]"
                                                    >
                                                        <img :src="getCompanyLogo" style="height: 100px"/>
                                                        <span v-if="getCompanyName"><br>{{getCompanyName}}</span>
                                                        <span><br>NIF: {{getNif}}</span>
                                                        <span><br>{{getLocation}}</span>
                                                        <span v-if="getCompanyPhone"><br>Tel: {{getCompanyPhone}}</span>
                                                        <span v-if="getCompanyEmail"><br>Email: {{getCompanyEmail}}</span>
                                                        <!--<span style="font-size: 13px"><br>{{getNib}}</span><br>-->
                                                        <span :style="[isInvoiceA5Format ? {'font-size': '10px'} : {'font-size':'12px'}]" v-if="getPrimaryNib"><br>{{getPrimaryNib}}</span>
                                                        <span :style="[isInvoiceA5Format ? {'font-size': '10px'} : {'font-size':'12px'}]" v-if="getSecondNib"><br>{{getSecondNib}}</span>
                                                    </td>

                                                </tr>
                                            </table>
                                            <!--</v-flex>-->
                                            <!--<v-flex xs-6 style="text-align: right; color: black; font-size: 12px">-->
                                            <table class="table table-bordered" :class="isInvoiceA5Format ? 'a5format' : 'a4format'" border="0" width="31%" style="padding: 0; margin: 0; margin-top: 50px; float: right">
                                                <tr >
                                                    <td align="right" style="padding: 0; margin: 0;"
                                                        :style="[isInvoiceA5Format ? {'font-size': '11px'} : {'font-size':'12px'}]"
                                                    >
                                                            <span v-if="getBudgetCode" style="font-weight: bold"
                                                                  :style="[isInvoiceA5Format ? {'font-size': '11px'} : {'font-size':'14px'}]"
                                                            >{{getDocumentName}} nº {{getBudgetCode}}</span>
                                                        <br><br>
                                                        <span>Exmo(a). Senhor(a)<br></span>
                                                        <span><b>{{getClientName()}}</b></span>
                                                        <span v-if="getClientNif()"><br>NIF: {{getClientNif()}}</span>
                                                        <span v-if="getClientPhone()"><br>Tel: {{getClientPhone()}}</span> <span v-else><br></span>
                                                        <span v-if="getClientEmail()"><br>Email: {{getClientEmail()}}</span> <span v-else><br></span>
                                                    </td>

                                                </tr>
                                            </table>
                                            <table width="100%" border="0" :class="isInvoiceA5Format ? 'a5format' : 'a4format'" style="padding: 0; margin-right: -10px; margin-bottom: -5px; float: right">
                                                <tr align="right">
                                                    <td align="right" >
                                                        <h4 v-if="getBudgetCode">{{invoicePrintLabel}}</h4>
                                                    </td>
                                                </tr>
                                            </table>


                                            <v-flex xs12>
                                                <table class="mytable table table-bordered" :class="isInvoiceA5Format ? 'a5format' : 'a4format'" border="1" width="100%" style="border-collapse: collapse;">
                                                    <tr align="left">
                                                        <th>Serie</th>
                                                        <th>Data emissão</th>
                                                        <th>Data vencimento</th>
                                                        <th>Moeda</th>
                                                        <th>pag.</th>
                                                    </tr>
                                                    <tr align="left">
                                                        <td>{{selectedBudget.series}}</td>
                                                        <td>{{selectedBudget.sell_date | formatDate }}</td>
                                                        <td>{{selectedBudget.due_date | formatDate }}</td>
                                                        <td>{{getCurrency}}</td>
                                                        <td>pag. 1/1</td>
                                                    </tr>
                                                </table>
                                                <br><br>
                                            </v-flex>
                                            <v-flex xs12>
                                                <table class="mytable table table-bordered" :class="isInvoiceA5Format ? 'a5format' : 'a4format'"  border="1" width="100%" style="border-collapse: collapse;">
                                                    <tr>
                                                        <th align="left">Cod.</th>
                                                        <th align="left" style="width: 40%">Descrição</th>
                                                        <th align="right">Qtd.</th>
                                                        <th align="right">Preço Unit.</th>
                                                        <th align="right">Desc.</th>
                                                        <th align="right">Valor</th>
                                                    </tr>
                                                    <tr v-for="(item, index) in sellLines" :key="index">
                                                        <td>{{item.article.code}}</td>
                                                        <td>{{item.article.name}}</td>
                                                        <td align="right">{{item.sold_quantity}}</td>
                                                        <td align="right">{{item.sell_price | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                                                        <td align="right">{{item.discount}}%</td>
                                                        <td align="right">{{item.subtotal | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' }) }}</td>
                                                    </tr>
                                                    <!--<tr v-if="selectedBudget.transport_cost">-->
                                                    <!--<td></td>-->
                                                    <!--<td>Transporte</td>-->
                                                    <!--<td></td><td></td><td></td>-->
                                                    <!--<td align="right">{{selectedBudget.transport_cost | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' }) }}</td>-->
                                                    <!--</tr>-->
                                                </table>
                                            </v-flex>

                                            <table class="table table-bordered" border="0" style="width: 100%; border-collapse: collapse; margin: 5px">
                                                <br><br>
                                                <tr>
                                                    <v-divider></v-divider>
                                                    <v-divider></v-divider>
                                                    <td style="width: 40%; padding: 0; vertical-align: top;">
                                                        <!--<table class="mytable table table-bordered" border="1" width="100%" style="border-collapse: collapse; padding: 0;">-->
                                                        <!--<tr>-->
                                                        <!--<th style="height: 25px; text-align: left">Taxa</th>-->
                                                        <!--<th style="height: 25px; text-align: left">Incidência</th>-->
                                                        <!--<th style="height: 25px; text-align: left">Imposto</th>-->
                                                        <!--</tr>-->
                                                        <!--<tr>-->
                                                        <!--<td style="height: 20px">{{taxPercentage}}%</td>-->
                                                        <!--<td style="height: 20px">{{getBaseIncidence | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>-->
                                                        <!--<td style="height: 20px">{{getComputedTaxMoney | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>-->
                                                        <!--</tr>-->
                                                        <!--</table>-->
                                                    </td>


                                                    <td style="width: 20%;">
                                                    </td>

                                                    <td style="width: 40%; padding: 0">
                                                        <table class="mytable table table-bordered" :class="isInvoiceA5Format ? 'a5format' : 'a4format'" border="1" style="border-collapse: collapse;  border-bottom: none; padding: 0; float: right; text-align:right;" >
                                                            <tr>
                                                                <td style="height: 25px; text-align: right;">SubTotal:</td>
                                                                <td style="height: 25px">{{ getSubTotal | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' }) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="height: 25px; text-align: right; border-bottom: none">Desconto:</td>
                                                                <td style="height: 25px; border-bottom: none">{{ getTotalDiscount | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' }) }}</td>
                                                            </tr>
                                                            <tr style="height: 10px"></tr>
                                                            <tr>
                                                                <td style="height: 25px; text-align: right; font-weight:bold; border-bottom: none">Total:</td>
                                                                <td style="height: 25px; border-bottom: none">{{ total | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                                                            </tr>
                                                            <tr>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </table>
                                            <v-flex style="margin-top: 10px" v-if="fetchedBudget.description">
                                                <v-divider></v-divider>
                                                <p style="font-size: 12px; margin-bottom: 2px">{{fetchedBudget.description}}</p>
                                            </v-flex>



                                            <!--<v-flex xs12>-->
                                            <!--<p style="font-size: 11px;" :style="{'margin-top': getPaddingTop + 'px'}">Tributo especial unificado (TEU) nos termos da lei da alínea 3 do artigo nr.28 Decreto-lei nr.70/VIII/2014 de Agosto de 2014.</p>-->
                                            <!--<v-divider></v-divider>-->
                                            <!--</v-flex>-->
                                            <!--<v-flex shrink>-->
                                            <!--<p style="font-size: 11px;">Processado pelo programa <b>NHA FATURA</b> licenciado pelo contribuinte./ &copy;<b>Laciftech</b></p>-->
                                            <!--</v-flex>-->
                                            <!--<v-spacer></v-spacer>-->
                                            <!--</v-layout>-->
                                        </div>
                                    </v-card>

                                </v-flex>

                            </v-flex>

                            <!--Side Buttons-->
                            <v-flex xs12 sm12 md3 lg2 style="margin-top: 25px">
                                <!--<v-layout row wrap>-->
                                    
                                <v-flex mx-2 xs12 v-if="selectedBudget.sell_id">
                                    <v-btn disabled block mx-2 grow color="success">Venda gerado</v-btn>
                                </v-flex>
                                <v-flex mx-2 xs12 v-else>
                                    <v-btn :disabled="!extraInfosLoaded || !getBudgetCode || selectedBudget.shelved===1
                                                || selectedBudget.pendent_value <= 0"
                                           block mx-2 grow color="success" @click="openSellWithBudget">Gerar venda</v-btn>
                                </v-flex>
                                <v-flex mx-2 xs12>
                                    <v-btn :disabled="!extraInfosLoaded || !getBudgetCode" block
                                           :loading="downloadingOriginal"
                                           class="white--text" mx-2 grow color="indigo lighten-2" @click="downloadPDF(DOWNLOAD_ORIGINAL)">Baixar Original</v-btn>
                                </v-flex>
                                <v-flex mx-2 xs12>
                                    <v-btn :disabled="!extraInfosLoaded || !getBudgetCode" block
                                           :loading="downloading2via"
                                           class="white--text" mx-2 grow color="indigo lighten-3" @click="downloadPDF(DOWNLOAD_2VIA)">Baixar 2ª via</v-btn>
                                </v-flex>
                                <v-flex mx-2 xs12>
                                    <v-btn :disabled="!extraInfosLoaded || shelving || !getBudgetCode "
                                           :loading="shelving"
                                           block
                                           class="white--text" mx-2 grow color="blue-grey lighten-3" @click="shelve">{{selectedBudget.shelved ? 'Desarquivar' : 'Arquivar'}}</v-btn>
                                </v-flex>

                                <!--</v-layout>-->
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>

        </v-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Types} from "../../config";
    import html2pdf from "html2pdf.js";
    import {mapGetters} from "vuex";
    import {eventBus} from "../../main";

    export default {
        name: 'BudgetModal',

        data(){
            return {
                Types,
                DOWNLOAD_ORIGINAL: 1,
                DOWNLOAD_2VIA: 2,

                loadingExtraBudgetInfos: false,
                extraInfosLoaded: false,
                openConfirmationDialog: false,
                openConfirmationDialogMultiInvoicePerReceipt: false,
                loading_delete_receipt: false,
                loading_cancel_invoice: false,
                shelving: false,
                sendingMail: false,
                currency: '',
                taxPercentage: '?',
                totalDiscount: 0,
                taxMoney: 0,
                total: 0,
                sellTotalValue: 0,
                invoicePrintLabel: 'Original',
                openCreditDebitLoading: false,
                downloadingOriginal: false,
                downloading2via: false,

                companyLogBase64: '',

                selectedReceiptId: '',
                selectedReceiptCode: '',
                selectedReceiptSeries: '',

                sellLines: [],
                payments: [],
                receipts: [],
                receiptInvoices: [],
                articles: [],

                trashReceiptReason: '',
                cancel_reason: '',
                invoiceCancelModal: false,

                //settings
                isInvoiceA5Format: false,
                isReceiptA5Format: false,
            }
        },

        props:[
            'paymentMethods'
        ],

        watch: {
            showBudgetModal(){
                if(this.showBudgetModal) this.onFormModalOpened();
            }
        },


        methods:{
            close(){
                // this.consoleLog('closed');
                this.showBudgetModal = false;
            },
            closeConfirmation(){
                this.openConfirmationDialog = false;
                this.loading_delete_receipt = false;
                this.trashReceiptReason = '';
                this.selectedReceiptId = '';
            },

            getClientName(){
                try{
                    // this.consoleLog('client: '+this.fetchedBudget.client.name);
                    return this.fetchedBudget.client.name;
                }catch (e) { console.log(e);return "";}
            },

            getClientNif(){
                try {
                    // this.consoleLog('nif: '+this.fetchedBudget.client.nif);
                    return this.fetchedBudget.client.nif;
                }catch (e) { return 'indefinido'; }
            },

            getClientPhone(){
                return this.getPhone(JSON.parse(this.fetchedBudget.client.contacts_json));
            },

            getClientEmail(){
                try{
                    let json = JSON.parse(this.fetchedBudget.client.contacts_json);
                    return json[0].email;
                }catch (e) { return ""}
            },

            loadExtraInfos(){
                console.log("-->Loading extra infos of Budget");
                this.loadingExtraBudgetInfos = true;
                Vue.axios.get('budget/'+this.selectedBudget.id)
                    .then(response=>{
                        this.consoleLog(response);
                        if (!response.data.success) {
                            this.loadingExtraBudgetInfos = false;
                            //do nothing
                            return;
                        }
                        this.consoleLog('loadingExtraBudgetInfos::::::::: ',response.data.response);
                        this.extraInfosLoaded = true;
                        this.fetchedBudget = response.data.response.budget;
                        this.sellLines = this.fetchedBudget.sell_lines;
                        // this.payments = this.fetchedBudget.payments;
                        // this.currency = this.fetchedBudget.sell.type_currency.name;
                        this.currency = 'ECV';
                        this.taxPercentage = this.fetchedBudget.sell_tax;
                        this.total = this.fetchedBudget.total_value;
                        // this.sellTotalValue = this.fetchedBudget.sell.total_value;
                        // this.receipts = this.fetchedBudget.receipts;
                        // this.receiptInvoices = this.fetchedBudget.receiptInvoices;

                        // this.companyLogBase64 = response.data.response.base64logo;

                        let settings = response.data.response.budget.company.settings;
                        this.setSettings(settings);

                    }).catch(error=>{
                    //Do nothing
                }).finally(()=>{
                    this.loadingExtraBudgetInfos = false;
                });
            },

            setSettings(settings){
                if (settings.length > 0){
                    this.isInvoiceA5Format = settings[0].invoice_format === "A5";
                    this.isReceiptA5Format = settings[0].receipt_format === "A5";

                }else{
                    this.isInvoiceA5Format = false;
                    this.isReceiptA5Format = false;
                }
            },

            getPhone(json){
                let mobile_phone = '', phone = '';
                try{
                    mobile_phone = json[0].mobile_phone;
                    phone = json[0].phone;

                    if(phone === null) phone = '';
                    if(mobile_phone === null) mobile_phone = '';
                }catch (e) {return ""}

                if(mobile_phone && phone)
                    return phone+" / "+mobile_phone;
                else if(!mobile_phone && !phone)
                    return '';
                else
                    return phone+""+mobile_phone;

            },

            onFormModalOpened(){
                this.consoleLog('onBudgetFormModalOpened');
                this.fetchedBudget = null;
                this.loadingExtraBudgetInfos = true;
                this.extraInfosLoaded = false;

                this.loadExtraInfos();
            },

            getNibFormatted(nib, nib_name){
                let nibRes = '';
                nibRes = nib_name ? "Nib_"+nib_name+": " : "Nib: ";

                return nib ? nibRes += nib : '';
            },

            downloadPDF(option){
                if (option === this.DOWNLOAD_ORIGINAL){
                    this.invoicePrintLabel = 'Original';
                    this.downloadingOriginal = true;
                }else if(option === this.DOWNLOAD_2VIA){
                    this.invoicePrintLabel = '2ª via';
                    this.downloading2via = true;
                }
                setTimeout(() => {
                    this.downloadPDFWorker();
                }, 200);

            },

            async downloadPDFWorker() {
                const el = this.$refs.factura;
                // this.loggedUser.group.company.image = "data:image/png;base64,aHR0cHM6Ly90cGMuZ29vZ2xlc3luZGljYXRpb24uY29tL3NpbWdhZC81NDAwMzI3MzAzMDE2ODQ4MjU3Ig==";

                let opt = {
                    margin:       0,
                    filename:     this.getFileName,
                    image:        { type: 'jpeg', quality: 1 },
                    // image:        { type: 'png', quality: 0.99 },
                    // html2canvas:  { dpi: 192, useCORS: true},
                    html2canvas:  { scale: 2 },
                    jsPDF:        { unit: 'in', format: this.isInvoiceA5Format ? 'a5' : 'a4', orientation: 'portrait', },
                    // footer: {
                    //     "height": "28mm",
                    //     "contents": {
                    //         first: 'Cover page',
                    //         1: 'Second page', // Any page number is working. 1-based index
                    //         default: '<span style="color: #444;">{{page}}</span>/<span>{{pages}}</span>', // fallback value
                    //         last: 'Last Page'
                    //     }},
                    pdfCallback: this.pdfCallback()
                };

                let pdf = html2pdf().from(el).set(opt);
                pdf.save();

                // this.toDataUrl(this.loggedUser.group.company.image, function(myBase64) {
                //     console.log(myBase64); // myBase64 is the base64 string
                //     this.loggedUser.group.company.image = myBase64;
                //     let pdf = html2pdf().from(el).set(opt);
                //     pdf.save();
                // });

            },

            toDataUrl(url, callback) {
                let xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        callback(reader.result);
                    };
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            },

            pdfCallback(){
                this.downloadingOriginal = false;
                this.downloading2via = false;
            },

            openSellWithBudget(){
                this.consoleLog('openSellWithBudget', this.selectedBudget);
                // return;
                // this.selectedSell = {
                //     // clients_id: this.selectedBudget.clients_id,
                //     // users_made_id: this.selectedBudget.users_made_id,
                //     sell_date: this.selectedBudget.sell_date,
                //     types_sell_channel_id: this.selectedBudget.types_sell_channel_id,
                //     operation_type: this.selectedBudget.operation_type,
                //     typology: this.selectedBudget.typology,
                //     series: this.selectedBudget.series,
                //     sell_lines: this.selectedBudget.sellLines,
                // };
                this.selectedSell = this.selectedBudget;
                this.showBudgetModal = false;
                
                this.$router.push({
                    name: 'sells',
                    params: { budgetParams: {
                        budget: this.selectedBudget,
                    }}
                });
            },

            shelve() {
                try{
                    this.shelving = true;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.put('invoice/shelve/'+this.selectedBudget.id, {
                        id: this.selectedBudget.id,
                        name: this.getBudgetCode,
                    }).then(response =>{
                        let str = !this.selectedBudget.shelved ? 'arquivado' : 'desarquivado';
                        if(!response.data.success){
                            this.showSnackBar('Erro ao '+str+' a orçamento '+this.getBudgetCode+'.', 'error');
                            return;
                        }
                        this.selectedBudget.shelved = response.data.response.invoice.shelved;
                        str = this.selectedBudget.shelved ? 'arquivado' : 'desarquivado';
                        this.showSnackBar('Orçamento '+this.getBudgetCode +' '+str+' com sucesso', 'success');
                        eventBus.$emit('onShelveUnshelve', true, this.selectedBudget);

                    }).catch(error => {
                        this.consoleLog(error);
                    }).finally(()=>{
                        this.shelving = false;
                    });
                }catch (e) {
                    //Do nothing for now
                }
            },

            sendEmail(){
                try{
                    this.sendingMail = true;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.post('invoice/sendmail', {
                        title: 'Nha titulo',
                        to_name: this.fetchedBudget.client.name,
                        to_email: this.getClientEmail,
                    }).then(response =>{
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.showSnackBar('Erro no envio do email.', 'error');
                            return;
                        }
                        this.showSnackBar('Email enviado', 'success');

                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Erro no envio do email.', 'error');
                    }).finally(()=>{
                        this.sendingMail = false;
                    });
                }catch (e) {
                    //Do nothing for now
                }
            }

        },

        computed:{
            ...mapGetters([
                'loggedUser',
                'getToken',
            ]),
            showBudgetModal: {
                get(){
                    return this.$store.getters.getShowBudgetModal;
                },
                set(value){
                    this.$store.dispatch('setShowBudgetModal', value);
                }
            },
            selectedBudget: {
                get(){
                    return this.$store.getters.getSelectedBudget;
                },
                set(value){
                    this.$store.dispatch('setSelectedBudget', value);
                }
            },
            showPaymentModal: {
                get(){ return this.$store.getters.getShowPaymentModal; },
                set(value){ this.$store.dispatch('setShowPaymentModal', value); }
            },
            selectedSell: {
                get(){
                    return this.$store.getters.getSelectedSell;
                },
                set(value){
                    this.$store.dispatch('setSelectedSell', value);
                }
            },
            showSellModal: {
                get(){
                    return this.$store.getters.getShowSellModal;
                },
                set(value){
                    this.$store.dispatch('setShowSellModal', value);
                }
            },


            showCreditDebitModal: {
                get(){
                    return this.$store.getters.setShowCreditDebitModal;
                },
                set(value){
                    this.$store.dispatch('setShowCreditDebitModal', value);
                }
            },

            //Used to make footer stick at the bottom
            getPaddingTop(){
                const padding = 30;
                let extraPadding = 0;
                if(this.fetchedBudget.total_installments){
                    extraPadding -= 100;
                }
                const maxPaddingMultiplier = 14;
                let quant = maxPaddingMultiplier - this.sellLines.length;
                return quant * padding + extraPadding;
            },

            getDocumentName(){
                return 'Orçamento';
            },

            getCurrency(){
                return 'ECV';
            },

            getNif(){
                let res = '';
                try{
                    res = this.fetchedBudget.company.nif;
                }catch (e) {/*Do nothing*/}

                return res;
            },
            getLocation(){
                let res = '';
                try{
                    res = 'Endereço: '+this.fetchedBudget.company.address+', '+this.fetchedBudget.company.city.name;
                }catch (e) { /*Do nothing*/}

                return res;
            },
            getCompanyLogo(){
                let res = '';
                try{
                    res = this.loggedUser.group.company.image_path;
                }catch (e) { /*Do nothing*/}

                return res;
            },
            getPrimaryNib(){
                let nib = '', nib_name = '';
                try{
                    try { nib = this.fetchedBudget.company.nib_bi; }catch (e) { /*Do nothing*/ }
                    try { nib_name = this.fetchedBudget.company.nib_bi_name; }catch (e) { /*Do nothing*/ }
                    return this.getNibFormatted(nib, nib_name);
                }catch (e) { return ''; }
            },
            getSecondNib(){
                let nib = '', nib_name = '';
                try{
                    try { nib = this.fetchedBudget.company.nib_bi2; }catch (e) { /*Do nothing*/ }
                    try { nib_name = this.fetchedBudget.company.nib_bi2_name; }catch (e) { /*Do nothing*/ }
                    return this.getNibFormatted(nib, nib_name);
                }catch (e) { return ''; }
            },
            getNib(){
                let res = '';

                let nib = '', nib_name = '', nib2 = '', nib2_name = '', firstNib = '', secondNib = '';
                try { nib = this.fetchedBudget.company.nib_bi; }catch (e) { /*Do nothing*/ }
                try { nib_name = this.fetchedBudget.company.nib_bi_name; }catch (e) { /*Do nothing*/ }
                try { nib2 = this.fetchedBudget.company.nib_bi2; }catch (e) { /*Do nothing*/ }
                try { nib2_name = this.fetchedBudget.company.nib_bi2_name; }catch (e) { /*Do nothing*/ }

                if(nib_name){
                    firstNib = "Nib_"+nib_name+": ";
                }else { firstNib = "Nib: ";}
                if(nib){
                    firstNib += nib;
                }else { firstNib="";}

                if(nib2_name){
                    secondNib = "Nib_"+nib2_name+": ";
                }else { secondNib = "Nib: ";}
                if(nib2){
                    secondNib += nib2;
                }else { secondNib="";}

                res = firstNib;
                if(firstNib && secondNib){
                    res = firstNib+' / '+secondNib;
                }else if(!firstNib){
                    res = secondNib;
                }



                return res;
            },

            getCompanyEmail(){
                try{
                    let json = JSON.parse(this.fetchedBudget.company.contacts_json);
                    return json[0].email;
                }catch (e) { return ""; }
            },


            getCompanyPhone(){
                this.consoleLog('this.fetchedBudget');
                this.consoleLog(this.fetchedBudget);
                return this.getPhone(JSON.parse(this.fetchedBudget.company.contacts_json));
            },

            // getClientName(){
            //     try{
            //         this.consoleLog('client: '+this.fetchedBudget.client.name);
            //         return this.fetchedBudget.client.name;
            //     }catch (e) { console.log(e);return "";}
            // },

            getCompanyName(){
                try{
                    return this.fetchedBudget.company.name;
                }catch (e) { return ""; }
            },

            // getClientPhone(){
            //     return this.getPhone(JSON.parse(this.fetchedBudget.client.contacts_json));
            // },

            // getClientEmail(){
            //     try{
            //         let json = JSON.parse(this.fetchedBudget.client.contacts_json);
            //         return json[0].email;
            //     }catch (e) { return ""}
            // },

            getComputedTaxMoney(){
                return this.fetchedBudget.sell_tax_money / this.fetchedBudget.total_installments;
            },

            getSubTotal(){
                let mSubtotal = 0;

                for(let i=0; i<this.sellLines.length; i++){
                    let sellLine = this.sellLines[i];
                    let soldQuantity = sellLine.sold_quantity ? sellLine.sold_quantity : 0;
                    let quantityToBeDelivered = !sellLine.quantity_to_be_delivery ? 0 : sellLine.quantity_to_be_delivery;

                    let subtotalNoDiscount = sellLine.sell_price * (soldQuantity);
                    mSubtotal += subtotalNoDiscount;

                }

                return mSubtotal;
            },

            getTotalDiscount(){
                // return this.getSubTotal - this.total;

                let totalDiscountValue = 0;
                let mSubtotal = 0;

                for(let i=0; i<this.sellLines.length; i++){
                    let sellLine = this.sellLines[i];
                    let soldQuantity = !sellLine.sold_quantity ? 0 : sellLine.sold_quantity;
                    let quantityToBeDelivered = !sellLine.quantity_to_be_delivery ? 0 : sellLine.quantity_to_be_delivery;

                    let subtotalNoDiscount = sellLine.sell_price * (soldQuantity + quantityToBeDelivered);
                    mSubtotal += subtotalNoDiscount;

                    let percentageDiscount = subtotalNoDiscount * sellLine.discount / 100;
                    totalDiscountValue += percentageDiscount;
                }

                return totalDiscountValue;
            },

            getTotalPaid(){
                return this.fetchedBudget.total_value - this.fetchedBudget.pendent_value;
            },

            getRawInstallmentFee(){
                return this.fetchedBudget.sell_tax
            },

            getFileName(){
                return 'Orçamento_'+this.fetchedBudget.code+''+this.fetchedBudget.series+'.pdf'
            },

            getBudgetCode(){
                if(!this.selectedBudget.code) return undefined;
                return this.selectedBudget.code + '/' + this.selectedBudget.series;
            },
        },

    }
</script>

<style scoped>

    table.a5format, .a5format tr, .a5format th, .a5format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 11px;
    }

    table.a4format, .a4format tr, .a4format th, .a4format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 14px;
    }

    table th{
        height: 40px;
    }

    table td{
        height: 30px;
    }


</style>